import { render } from "./VuexPrefectureFormItem.vue?vue&type=template&id=618cc20e"
import script from "./VuexPrefectureFormItem.vue?vue&type=script&lang=js"
export * from "./VuexPrefectureFormItem.vue?vue&type=script&lang=js"
script.render = render

export default script